import React from "react";
import { BsArrowClockwise } from "react-icons/bs";

export const RetryIcon = ({ onClick, animated = true }) => {
  return (
    <button type="button" className="btn retry-button" onClick={onClick}>
      <BsArrowClockwise
        alt="Retry"
        title="Retry"
        className="retry-icon-animated"
      />
    </button>
  );
};
